module.exports = new __parcel__URL__("svg-error-window_ptc.150cf151.svg").toString();